export default "__VITE_ASSET__BK33ZDHP__"